export const percentageChange = (first: number, second: number) => {
    return (first - second) / second * 100
}